import { useFormContext, useFormState, useWatch } from "react-hook-form";

import { RenderElement } from "@up/form";

export function CollegeCurrentSchoolCountry({
  label = "Current School Country",
}: {
  label?: string;
}) {
  const { control, register } = useFormContext();
  const { errors } = useFormState();
  const formValues = useWatch();

  return (
    <RenderElement
      control={control}
      element={{
        _id: "college-current-school-address-country",
        type: "countryselect",
        name: "college-current-school-address-country",
        label: label,
        validate: { presence: true },
      }}
      errors={errors}
      formValues={formValues}
      register={register}
      wrapperProps={{ className: "mb-8" }}
    />
  );
}
